import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../components/Component";
const OrgProfileAside = ({ updateSm, sm }) => {
    // const [profileName, setProfileName] = useState("Abu Bin Ishtiak");

    useEffect(() => {
        sm ? document.body.classList.add("toggle-shown") : document.body.classList.remove("toggle-shown");
    }, [sm])

    return (
        <div className="card-inner-group">
            <div className="card-inner">
                <div className="user-card">
                    {/* <UserAvatar text={findUpper(profileName)} theme="primary" /> */}
                    <div className="user-info">
                        <span className="lead-text">Organisation Details</span>
                        {/* <span className="sub-text">info@softnio.com</span> */}
                    </div>
                    {/* <div className="user-action">
                        <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="btn btn-icon btn-trigger me-n2">
                                <Icon name="more-v"></Icon>
                            </DropdownToggle>
                            <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                    <li>
                                        <DropdownItem
                                            tag="a"
                                            href="#dropdownitem"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                            }}
                                        >
                                            <Icon name="camera-fill"></Icon>
                                            <span>Change Photo</span>
                                        </DropdownItem>
                                    </li>
                                    <li>
                                        <DropdownItem
                                            tag="a"
                                            href="#dropdownitem"
                                            onClick={(ev) => {
                                                ev.preventDefault();
                                            }}
                                        >
                                            <Icon name="edit-fill"></Icon>
                                            <span>Update Profile</span>
                                        </DropdownItem>
                                    </li>
                                </ul>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div> */}
                </div>
            </div>
            {/* <div className="card-inner"> */}
                {/* <div className="user-account-info py-0">
                    <h6 className="overline-title-alt">Nio Wallet Account</h6>
                    <div className="user-balance">
                        12.395769 <small className="currency currency-btc">BTC</small>
                    </div>
                    <div className="user-balance-sub">
                        Locked{" "}
                        <span>
                            0.344939 <span className="currency currency-btc">BTC</span>
                        </span>
                    </div>
                </div> */}
            {/* </div> */}
            <div className="card-inner p-0">
                <ul className="link-list-menu">
                    <li onClick={() => updateSm(false)}>
                        <Link
                            to={`${process.env.PUBLIC_URL}/organisation`}
                            className={
                                window.location.pathname === `${process.env.PUBLIC_URL}/organisation` ? "active" : ""
                            }
                        >
                            <Icon name="user-fill-c"></Icon>
                            <span>General Information</span>
                        </Link>
                    </li>
                    <li onClick={() => updateSm(false)}>
                        <Link
                            to={`${process.env.PUBLIC_URL}/orgLegalInformation`}
                            className={
                                window.location.pathname === `${process.env.PUBLIC_URL}/orgLegalInformation`
                                    ? "active"
                                    : ""
                            }
                        >
                            <Icon name="bell-fill"></Icon>
                            <span>Legal Information</span>
                        </Link>
                    </li>
                    <li onClick={() => updateSm(false)}>
                        <Link
                            to={`${process.env.PUBLIC_URL}/orgContactInformation`}
                            className={
                                window.location.pathname === `${process.env.PUBLIC_URL}/orgContactInformation` ? "active" : ""
                            }
                        >
                            <Icon name="lock-alt-fill"></Icon>
                            <span>Contact Information</span>
                        </Link>
                    </li>
                    <li onClick={() => updateSm(false)}>
                        <Link
                            to={`${process.env.PUBLIC_URL}/orgBankInformation`}
                            className={
                                window.location.pathname === `${process.env.PUBLIC_URL}/orgBankInformation` ? "active" : ""
                            }
                        >
                            <Icon name="lock-alt-fill"></Icon>
                            <span>Bank Details</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default OrgProfileAside;
